/**
 * ContentRepository module
 *
 * This module create shortcut with a request
 * to the API
 *
 */

'use strict';

const jQuery = require('jquery');

const RequestHandler = require('./../../../core/requestHandler');

let colors = null;
let fonts = null;
let shapes = null;

module.exports.getAllThemes = function() {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd;

    RequestHandler.setBaseUrl('/api');

    dfd = RequestHandler.read('theme-colors');

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};

module.exports.getCurrentTheme = function() {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd;

    RequestHandler.setBaseUrl('/api');

    dfd = RequestHandler.read('current-theme');

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};

module.exports.changeTheme = function(data) {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let result;

    RequestHandler.setBaseUrl('/api');

    result = RequestHandler.update('color-panel/change-theme', data);

    RequestHandler.setBaseUrl(currentApiUrl);

    return result;
};

module.exports.getAllColors = function() {
    let dfd = jQuery.Deferred();

    if (colors !== null) {
        dfd.resolve(colors);
    } else {
        let currentApiUrl = RequestHandler.getBaseUrl();

        RequestHandler.setBaseUrl('/api');

        RequestHandler.read('color-panel/colors').done((data) => {
            colors = data;
            dfd.resolve(colors);
        });

        RequestHandler.setBaseUrl(currentApiUrl);
    }

    return dfd.promise();
};

module.exports.getStaticAllColors = () => colors;

module.exports.getColorPanel = function() {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd;

    RequestHandler.setBaseUrl('/api');

    dfd = RequestHandler.read('color-panel');

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};

module.exports.updateColorPanel = function(data) {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let result;

    RequestHandler.setBaseUrl('/api');

    result = RequestHandler.update('color-panel', data);

    RequestHandler.setBaseUrl(currentApiUrl);

    return result;
};

module.exports.getAllFonts = function() {
    let dfd = jQuery.Deferred();

    if (fonts !== null) {
        dfd.resolve(fonts);
    } else {
        let currentApiUrl = RequestHandler.getBaseUrl();

        RequestHandler.setBaseUrl('/api');

        RequestHandler.read('design/fonts').done((data) => {
            fonts = data;
            dfd.resolve(fonts);
        });

        RequestHandler.setBaseUrl(currentApiUrl);
    }

    return dfd.promise();
};

module.exports.getStaticAllFonts = () => fonts;

module.exports.getAllShapes = function() {
    let dfd = jQuery.Deferred();

    if (shapes !== null) {
        dfd.resolve(shapes);
    } else {
        let currentApiUrl = RequestHandler.getBaseUrl();

        RequestHandler.setBaseUrl('/api');

        RequestHandler.read('design/button-settings/shapes').done((data) => {
            shapes = data;
            dfd.resolve(shapes);
        });

        RequestHandler.setBaseUrl(currentApiUrl);
    }

    return dfd.promise();
};

module.exports.getStaticAllShapes = () => shapes;

module.exports.getBtnSettings = function() {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd;

    RequestHandler.setBaseUrl('/api');

    dfd = RequestHandler.read('design/button-settings');

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};

module.exports.updateBtnSettings = function(data) {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let result;

    RequestHandler.setBaseUrl('/api');

    result = RequestHandler.update('design/button-settings', data);

    RequestHandler.setBaseUrl(currentApiUrl);

    return result;
};

module.exports.getGlobalContentColors = function() {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd;

    RequestHandler.setBaseUrl('/api');

    dfd = RequestHandler.read('design/global-content-settings');

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};

module.exports.updateGlobalContentSettings = function(data) {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let result;

    RequestHandler.setBaseUrl('/api');

    result = RequestHandler.update('design/global-content-settings', data);

    RequestHandler.setBaseUrl(currentApiUrl);

    return result;
};
